import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	root: {
		"& .MuiButtonBase-root": {
			padding: "0px 9px",
		},
	},
	formControl: {
		alignItems: "center",
		flexDirection: "row",
	},
	formControlAlt: {
		flexDirection: "column",
	},
	formLabel: {
		fontSize: "14px",
		lineHeight: 1.43,
		color: theme.palette.common.black,
		letterSpacing: "0.4px",
		marginBottom: "8px",
		marginRight: "20px",
	},

	formLabelFocused: {
		color: theme.palette.common.black,
	},
	helperLabel: {
		marginTop: "8px",
		fontSize: "12px",
		lineHeight: "normal",
		letterSpacing: "0.4px",
		color: theme.palette.secondary.light,
	},
	helperLabelFocused: {
		color: `${theme.palette.secondary.light} !important`,
	},
	radioOptions: {
		marginLeft: "-8px",
		marginRight: "8px",
	},
	radioLabelOptions: {
		lineHeight: 1.43,
		color: theme.palette.grey[900],
		"> *": {
			fontSize: "14px !important",
		},
	},
	radioDisabled: {
		opacity: "0.4",
	},
	radioControlRoot: {
		borderRadius: "4px !important",
		"&:hover": {
			backgroundColor: "transparent !important",
		},
	},

	group: {
		flexDirection: "row",
	},
	groupColumn: {
		gap: "8px",
		flexDirection: "column",
	},
	fromLabel18: {
		fontSize: "18px !important",
	},
	radioErrLabel: {
		margin: "0px",
	},
	minWidth: {
		minWidth: "130px",
	},
	minWidthStageDetails: {
		minWidth: "50px",
	},
});
export default styles;
